<template>
    <div class="cmp-listing-list">
        <h1 v-if="isPrimary && list.length > 0" :class="[{ 'active': list.length > 0 }, 'section-heading']">
            <span class="icon-heading"><icon class="icon" type="solid" :name="displayIcon" aria-hidden="true"></icon> {{display}}</span>
            <span :class="[{ 'toggle-icon-active': list.length > 0 }, 'toggle-icon']"><icon type="solid" name="faChevronDown" aria-hidden="true"></icon></span>
        </h1>
        <h2 v-if="!isPrimary && list.length > 0" :class="[{ 'active': list.length > 0 }, 'section-heading']">
            <span class="icon-heading"><icon class="icon" type="solid" :name="displayIcon" aria-hidden="true"></icon> {{display}}</span>
            <span :class="[{ 'toggle-icon-active': list.length > 0 }, 'toggle-icon']"><icon type="solid" name="faChevronDown" aria-hidden="true"></icon></span>
        </h2>

        <div v-if="showFilter" class="td-card rounded md-col-2 listing-filters">
            <div>
                <strong><label class="td-inline" for="cmp-listing-list-region">Filter by State/Prov.</label></strong>
                <select id="cmp-listing-list-region" v-model="regionFilter" :disabled="loading" class="td-select">
                    <option value="">Filter by state/prov. (optional)</option>
                    <optgroup label="United States">
                        <option v-for="item in usRegions" :value="item.code">{{ item.name }}</option>
                    </optgroup>
                    <optgroup label="Canada">
                        <option v-for="item in caRegions" :value="item.code">{{ item.name }}</option>
                    </optgroup>
                </select>
            </div>
            <div v-if="showPublished" class="form-field">
                <label class="td-checkbox-label" for="cmp-listing-list-published">
                    Only include published listings
                    <input id="cmp-listing-list-published" type="checkbox" v-model="published" :disabled="loading" />
                    <span></span>
                </label>
            </div>
        </div>

        <div v-if="list.length > 0" class="content">
            <div v-if="showFilter" class="listing-list-pagination pagination td-card shadow top">
                <div class="td-text-subdued td-text-italic td-text-mice">
                    {{ pagerText }}
                </div>
                <div class="td-pagination-btns my-1 slim">
                    <button :disabled="!enablePrevious" :class="['secondary', 'previous', {'disabled': !enablePrevious}]"
                            @click.prevent="onPrevious"
                            title="Previous Page">
                        <icon v-if="loading" type="solid" name="faSpinner" spin aria-hidden="true"></icon>
                        <icon v-if="!loading" type="solid" name="faAngleLeft" aria-hidden="true"></icon>
                    </button>
                    <button :class="['next', 'secondary', {'disabled': !enableNext}]"
                            @click.prevent="onNext"
                            title="Next"
                            :disabled="!enableNext">
                        <icon v-if="loading" type="solid" name="faSpinner" spin aria-hidden="true"></icon>
                        <icon v-if="!loading" type="solid" name="faAngleRight" aria-hidden="true"></icon>
                    </button>
                </div>
            </div>
            <div v-for="preListing in preListings" :key="preListing.id">
                <listing :listing="preListing" :list="name"
                         :all-services="allServices"
                         :enable-map="enableListingMaps"
                         :promotion-id="getPromoId(preListing.id)"
                         :disable-requests="disableRequests"></listing>
            </div>
            <lazy v-for="listing in lazyListings" :key="listing.id">
                <listing :listing="listing" :list="name"
                         :all-services="allServices"
                         :enable-map="enableListingMaps"
                         :promotion-id="getPromoId(listing.id)"
                         :disable-requests="disableRequests"></listing>
                <template v-slot:fallback>
                    <div :class="'cmp-listing placeholder ' + getListingClass(listing.properties.type)"></div>
                </template>
            </lazy>
            <div v-if="showFilter" class="pagination td-card bottom shadow">
                <div class="td-text-subdued td-text-italic td-text-mice">
                    {{ pagerText }}
                </div>
                <div class="td-pagination-btns my-1 slim">
                    <button :disabled="!enablePrevious" :class="['secondary', 'previous', {'disabled': !enablePrevious}]"
                            @click.prevent="onPrevious"
                            title="Previous Page">
                        <icon v-if="loading" type="solid" name="faSpinner" spin aria-hidden="true"></icon>
                        <icon v-if="!loading" type="solid" name="faAngleLeft" aria-hidden="true"></icon>
                    </button>
                    <button :class="['next', 'secondary', {'disabled': !enableNext}]"
                            @click.prevent="onNext"
                            title="Next"
                            :disabled="!enableNext">
                        <icon v-if="loading" type="solid" name="faSpinner" spin aria-hidden="true"></icon>
                        <icon v-if="!loading" type="solid" name="faAngleRight" aria-hidden="true"></icon>
                    </button>
                </div>
            </div>
        </div>

        <div v-if="moreBlock">
            <span class="td-banner danger slim no-icon">Our system has detected activity that represents a risk to our system, our users, or the businesses listed. As a result of this risk, your access has been restricted.</span>
        </div>
        <div v-if="moreCaptcha">
            <span class="captcha td-banner warning no-icon slim">Please verify that you are not an automated bot.</span>
            <div is="vue:captcha" @success="enableMore" instance="listingList"></div>
        </div>

        <div v-if="showMore">
            <div v-if="moreWarning.length > 0">
                <span class="captcha td-banner warning no-icon slim">{{ moreWarning }}</span>
            </div>
            <button @click="loadMore" class="td-btn primary-outlined td-full-width">
                <icon v-if="loading" type="solid" name="faSpinner" spin aria-hidden="true"></icon>
                <span v-else>Load More</span>
            </button>
        </div>
    </div>
</template>

<script>import script from './ListingList';
    export default script;</script>

<style lang="less">
    @import "./ListingList.less";
</style>
